var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommunityIcn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 120,
    viewBox: "0 0 135 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.4822V80.6911C0 88.6867 6.57386 95.1733 14.6899 95.1733H80.8694L104.125 120V95.1711H119.61C127.721 95.1711 134.3 88.6844 134.3 80.6889V14.4822C134.297 6.48445 127.721 0 119.61 0H14.6899C6.57386 0 0 6.48445 0 14.4822ZM93.5471 47.5844C93.5471 42.4444 97.773 38.2756 102.99 38.2756C108.208 38.2756 112.434 42.4444 112.434 47.5844C112.434 52.7289 108.208 56.8956 102.99 56.8956C97.773 56.8956 93.5471 52.7311 93.5471 47.5844ZM57.7054 47.5844C57.7054 42.4444 61.9357 38.2756 67.1487 38.2756C72.3617 38.2756 76.5921 42.4444 76.5921 47.5844C76.5921 52.7289 72.3617 56.8956 67.1487 56.8956C61.9357 56.8956 57.7054 52.7311 57.7054 47.5844ZM21.8659 47.5844C21.8659 42.4444 26.0962 38.2756 31.3092 38.2756C36.5267 38.2756 40.7526 42.4444 40.7526 47.5844C40.7526 52.7289 36.5267 56.8956 31.3092 56.8956C26.094 56.8978 21.8659 52.7311 21.8659 47.5844Z",
    fill: "#131316",
    fillOpacity: 0.05
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityIcn);
export default __webpack_public_path__ + "static/media/community-icn.6ccf103bf065aaec1be8ea4cddcb9511.svg";
export { ForwardRef as ReactComponent };